import styled from 'styled-components';

import {
  Flex,
} from 'web-styled';

export const Video = styled(Flex).attrs({
  fillSpace: true,
})`
  position: relative;
  overflow: hidden;
  padding-bottom: 52.25%;
  padding-top: 25px;
  height: 0;
  width: 100%;
`;

export const Frame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;

export const Placeholder = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  spacing: 15,
  column: true,
})`
  color: #c1c1c1;
  font-size: 14px;
  width: 100%;
  text-align: center;
  line-height: 16px;
  background: #f9f9f9;

  ${props => props.isRounded && `
    border-radius: 5px;
    border: 1px solid #ededed;
  `};
`;

export const PlaceholderIcon = styled.div`
  height: 78px;
  width: 78px;
  color: ${props => props.theme.colors.primary};
  font-size: 30px;
  line-height: 84px;
  margin: 0 auto 15px;
  padding-left: 5px;
  background: #fefefe;
  border-radius: 100px;
`;

export const Controls = styled(Flex).attrs({
  flex: '0 0 50px',
  align: 'center',
  justify: 'space-between',
})`
  width: 100%;
  padding: 0 17px;
  background-color: #f9f9f9;
`;
